webpackJsonp([5],{

/***/ 561:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsMakeArray = __webpack_require__(220);
	
	var _utilsMakeArray2 = _interopRequireDefault(_utilsMakeArray);
	
	var _SpinnerScss = __webpack_require__(562);
	
	var _SpinnerScss2 = _interopRequireDefault(_SpinnerScss);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var sizes = {
	  xs: 20,
	  s: 40,
	  m: 84,
	  l: 120
	};
	
	var squares = (0, _utilsMakeArray2['default'])(2);
	var lines = (0, _utilsMakeArray2['default'])(4);
	
	var Spinner = (function (_React$Component) {
	  _inherits(Spinner, _React$Component);
	
	  function Spinner() {
	    _classCallCheck(this, _Spinner);
	
	    _get(Object.getPrototypeOf(_Spinner.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Spinner, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var _props$size = _props.size;
	      var size = _props$size === undefined ? 'm' : _props$size;
	      var _props$color = _props.color;
	      var color = _props$color === undefined ? '#2AB8D5' : _props$color;
	      var _props$style = _props.style;
	      var style = _props$style === undefined ? {} : _props$style;
	
	      var props = _objectWithoutProperties(_props, ['size', 'color', 'style']);
	
	      var width = sizes[size];
	      var height = width * 0.68;
	      var small = size === 's' || size === 'xs';
	
	      return _react2['default'].createElement(
	        'div',
	        _extends({
	          className: (0, _SpinnerScss2['default'])('main'),
	          style: _extends({}, style, {
	            width: height,
	            height: height,
	            margin: '0 ' + Math.round(height / 2) + 'px'
	          })
	        }, props),
	        {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: squares.map(function (j) {
	              return {
	                $$typeof: _typeofReactElement,
	                type: 'div',
	                key: j,
	                ref: null,
	                props: {
	                  children: lines.map(function (i) {
	                    return {
	                      $$typeof: _typeofReactElement,
	                      type: 'div',
	                      key: i,
	                      ref: null,
	                      props: {
	                        children: [{
	                          $$typeof: _typeofReactElement,
	                          type: 'div',
	                          key: null,
	                          ref: null,
	                          props: {
	                            className: (0, _SpinnerScss2['default'])('dot', { small: small }),
	                            style: {
	                              backgroundColor: color
	                            }
	                          },
	                          _owner: null
	                        }, {
	                          $$typeof: _typeofReactElement,
	                          type: 'div',
	                          key: null,
	                          ref: null,
	                          props: {
	                            className: (0, _SpinnerScss2['default'])('dot', { small: small }),
	                            style: {
	                              backgroundColor: color
	                            }
	                          },
	                          _owner: null
	                        }],
	                        className: (0, _SpinnerScss2['default'])('line', [i + 1]),
	                        style: {
	                          backgroundColor: color
	                        }
	                      },
	                      _owner: null
	                    };
	                  }),
	                  className: (0, _SpinnerScss2['default'])('sq', [j + 1])
	                },
	                _owner: null
	              };
	            }),
	            className: (0, _SpinnerScss2['default'])('w')
	          },
	          _owner: null
	        },
	        {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: squares.map(function (j) {
	              return {
	                $$typeof: _typeofReactElement,
	                type: 'div',
	                key: j,
	                ref: null,
	                props: {
	                  children: lines.map(function (i) {
	                    return {
	                      $$typeof: _typeofReactElement,
	                      type: 'div',
	                      key: i,
	                      ref: null,
	                      props: {
	                        children: [{
	                          $$typeof: _typeofReactElement,
	                          type: 'div',
	                          key: null,
	                          ref: null,
	                          props: {
	                            className: (0, _SpinnerScss2['default'])('dot', { small: small }),
	                            style: {
	                              backgroundColor: color
	                            }
	                          },
	                          _owner: null
	                        }, {
	                          $$typeof: _typeofReactElement,
	                          type: 'div',
	                          key: null,
	                          ref: null,
	                          props: {
	                            className: (0, _SpinnerScss2['default'])('dot', { small: small }),
	                            style: {
	                              backgroundColor: color
	                            }
	                          },
	                          _owner: null
	                        }],
	                        className: (0, _SpinnerScss2['default'])('line', [i + 1]),
	                        style: {
	                          backgroundColor: color
	                        }
	                      },
	                      _owner: null
	                    };
	                  }),
	                  className: (0, _SpinnerScss2['default'])('sq', [j + 1])
	                },
	                _owner: null
	              };
	            }),
	            className: (0, _SpinnerScss2['default'])('w')
	          },
	          _owner: null
	        }
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      size: _react.PropTypes.oneOf(Object.keys(sizes)),
	      color: _react.PropTypes.string,
	      style: _react.PropTypes.object
	    },
	    enumerable: true
	  }]);
	
	  var _Spinner = Spinner;
	  Spinner = (0, _decoratorsWithStyles2['default'])(_SpinnerScss2['default'])(Spinner) || Spinner;
	  return Spinner;
	})(_react2['default'].Component);
	
	exports['default'] = Spinner;
	module.exports = exports['default'];

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(563);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(564);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./Spinner.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./Spinner.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 564:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes _24OOaBDnVW{20%{opacity:1;transform:rotate(0)}42%,to{transform:rotate(45deg);opacity:0}}@keyframes _3TauKukHyp{28%{opacity:1;transform:rotate(90deg)}42%,to{transform:rotate(135deg);opacity:0}}@keyframes _3lgTdLIZr6{38%{opacity:1;transform:rotate(180deg)}52%,to{transform:rotate(225deg);opacity:0}}@keyframes _2vita4-laV{38%{opacity:1;transform:rotate(270deg)}60%,to{transform:rotate(315deg);opacity:0}}._3PVoy5tLIw{position:relative;display:inline-block;transform:translate3d(0,0,0)}._2efPtquNwR{width:70%;height:70%;position:absolute}._2efPtquNwR:first-child{left:-34%;transform:rotate(90deg)}._2efPtquNwR:last-child{right:-34%;transform:scaleY(-1) rotate(180deg)}._1Q0hTtEYe9{position:absolute;width:100%;height:100%}._2efPtquNwR:first-child ._1bdad01N0E,._2efPtquNwR:first-child ._3A25yOg-3Q{display:block;transform:rotate(225deg) scaleX(-1)}._2efPtquNwR:last-child ._1bdad01N0E,._2efPtquNwR:last-child ._3A25yOg-3Q{transform:rotate(135deg)}._2efPtquNwR:last-child ._1bdad01N0E ._2zQ9VdlE_P,._2efPtquNwR:last-child ._3A25yOg-3Q ._2zQ9VdlE_P{animation-delay:1.5s}._2efPtquNwR:first-child ._1bdad01N0E{transform:rotate(225deg) scaleX(-1) scaleY(-1)}._2efPtquNwR:first-child ._1bdad01N0E ._2zQ9VdlE_P{animation-direction:reverse}._2efPtquNwR:last-child ._1bdad01N0E{transform:rotate(135deg) scaleY(-1)}._2efPtquNwR:last-child ._1bdad01N0E ._2zQ9VdlE_P{animation-direction:reverse}._2zQ9VdlE_P{position:absolute;width:1px;height:100%;transform-origin:50% 0;display:none}._2-9g6aCdsk{display:block;left:0;top:0;animation:_24OOaBDnVW 1s infinite}._30LSHaS5dZ{display:block;left:100%;transform:rotate(90deg);animation:_3TauKukHyp 1s infinite}._3xrHE2SP4_{display:block;left:100%;top:100%;transform:rotate(180deg);animation:_3lgTdLIZr6 1s infinite}._8CYkvVjQk3{display:block;left:0;top:100%;transform:rotate(270deg);animation:_2vita4-laV 1s infinite}._2zQ9VdlE_P .s7gl2Jghjq{position:absolute;width:3px;height:3px;border-radius:50%}._2zQ9VdlE_P .s7gl2Jghjq:first-child{top:-1px;left:-1px}._2zQ9VdlE_P .s7gl2Jghjq:last-child{bottom:-1px;left:-1px}._2zQ9VdlE_P ._1Ilsx-24xG{width:2px;height:2px;left:0!important}", ""]);
	
	// exports
	exports.locals = {
		"main": "_3PVoy5tLIw",
		"w": "_2efPtquNwR",
		"sq": "_1Q0hTtEYe9",
		"sq--1": "_1bdad01N0E",
		"sq--2": "_3A25yOg-3Q",
		"line": "_2zQ9VdlE_P",
		"line--1": "_2-9g6aCdsk",
		"fly_1": "_24OOaBDnVW",
		"line--2": "_30LSHaS5dZ",
		"fly_2": "_3TauKukHyp",
		"line--3": "_3xrHE2SP4_",
		"fly_3": "_3lgTdLIZr6",
		"line--4": "_8CYkvVjQk3",
		"fly_4": "_2vita4-laV",
		"dot": "s7gl2Jghjq",
		"dot--small": "_1Ilsx-24xG"
	};

/***/ }),

/***/ 606:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsIcon = __webpack_require__(53);
	
	var _componentsIcon2 = _interopRequireDefault(_componentsIcon);
	
	var _componentsButton = __webpack_require__(93);
	
	var _componentsButton2 = _interopRequireDefault(_componentsButton);
	
	var _componentsActionLink = __webpack_require__(51);
	
	var _componentsActionLink2 = _interopRequireDefault(_componentsActionLink);
	
	var _componentsFastSignupButtonWrapper = __webpack_require__(160);
	
	var _componentsFastSignupButtonWrapper2 = _interopRequireDefault(_componentsFastSignupButtonWrapper);
	
	var Subscribe = (function (_React$Component) {
	  _inherits(Subscribe, _React$Component);
	
	  function Subscribe() {
	    _classCallCheck(this, Subscribe);
	
	    _get(Object.getPrototypeOf(Subscribe.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(Subscribe, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var type = _props.type;
	      var fastSignupParams = _props.fastSignupParams;
	
	      var props = _objectWithoutProperties(_props, ['type', 'fastSignupParams']);
	
	      var Comp = components[type];
	
	      return {
	        $$typeof: _typeofReactElement,
	        type: _componentsFastSignupButtonWrapper2['default'],
	        key: null,
	        ref: null,
	        props: _defaultProps(_componentsFastSignupButtonWrapper2['default'].defaultProps, {
	          children: _react2['default'].createElement(Comp, props),
	          submitLabel: "Подписаться",
	          fastSignupParams: fastSignupParams
	        }),
	        _owner: null
	      };
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      counter: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]).isRequired,
	      subscribed: _react.PropTypes.bool.isRequired,
	      onClick: _react.PropTypes.func.isRequired,
	      theme: _react.PropTypes.string.isRequired,
	      fastSignupParams: _react.PropTypes.object,
	      type: _react.PropTypes.oneOf(['button', 'link'])
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      theme: 'gray',
	      subscribed: false,
	      counter: 0,
	      type: 'button'
	    },
	    enumerable: true
	  }]);
	
	  return Subscribe;
	})(_react2['default'].Component);
	
	exports['default'] = Subscribe;
	
	var components = {
	  button: SubscribeButton,
	  link: SubscribeLink
	};
	
	function SubscribeButton(_ref) {
	  var counter = _ref.counter;
	  var subscribed = _ref.subscribed;
	  var onClick = _ref.onClick;
	
	  return {
	    $$typeof: _typeofReactElement,
	    type: _componentsButton2['default'],
	    key: null,
	    ref: null,
	    props: _defaultProps(_componentsButton2['default'].defaultProps, {
	      children: [{
	        $$typeof: _typeofReactElement,
	        type: 'span',
	        key: null,
	        ref: null,
	        props: {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: _componentsIcon2['default'],
	            key: null,
	            ref: null,
	            props: _defaultProps(_componentsIcon2['default'].defaultProps, {
	              type: subscribed ? 'star' : 'star-stroke'
	            }),
	            _owner: null
	          }, ' ', {
	            $$typeof: _typeofReactElement,
	            type: 'span',
	            key: null,
	            ref: null,
	            props: {
	              children: counter,
	              className: 'count'
	            },
	            _owner: null
	          }],
	          className: 'btn__cntr'
	        },
	        _owner: null
	      }, {
	        $$typeof: _typeofReactElement,
	        type: 'span',
	        key: null,
	        ref: null,
	        props: {
	          children: subscribed ? "Отписаться" : "Подписаться"
	        },
	        _owner: null
	      }],
	      onClick: onClick,
	      className: subscribed ? 'st-active' : '',
	      size: 'tiny',
	      theme: 'gray'
	    }),
	    _owner: null
	  };
	}
	
	function SubscribeLink(_ref2) {
	  var counter = _ref2.counter;
	  var subscribed = _ref2.subscribed;
	  var onClick = _ref2.onClick;
	
	  return {
	    $$typeof: _typeofReactElement,
	    type: _componentsActionLink2['default'],
	    key: null,
	    ref: null,
	    props: _defaultProps(_componentsActionLink2['default'].defaultProps, {
	      children: [subscribed ? "Отписаться" : "Подписаться", ' (', counter, ')'],
	      icon: subscribed ? 'star' : 'star-stroke',
	      onClick: onClick
	    }),
	    _owner: null
	  };
	}
	module.exports = exports['default'];

/***/ }),

/***/ 645:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(84);
	
	var _lodashFunctionThrottle = __webpack_require__(642);
	
	var _lodashFunctionThrottle2 = _interopRequireDefault(_lodashFunctionThrottle);
	
	var _componentsSmartMenu = __webpack_require__(646);
	
	var _componentsSmartMenu2 = _interopRequireDefault(_componentsSmartMenu);
	
	var _componentsGoalCard = __webpack_require__(647);
	
	var _componentsGoalCard2 = _interopRequireDefault(_componentsGoalCard);
	
	var _componentsSpinner = __webpack_require__(561);
	
	var _componentsSpinner2 = _interopRequireDefault(_componentsSpinner);
	
	var _componentsGoalsSearch = __webpack_require__(652);
	
	var _componentsGoalsSearch2 = _interopRequireDefault(_componentsGoalsSearch);
	
	var _componentsGoalCardWrapper = __webpack_require__(648);
	
	var _componentsGoalCardWrapper2 = _interopRequireDefault(_componentsGoalCardWrapper);
	
	var _Specials = __webpack_require__(666);
	
	var _Specials2 = _interopRequireDefault(_Specials);
	
	var _MostActive = __webpack_require__(678);
	
	var _MostActive2 = _interopRequireDefault(_MostActive);
	
	var _MostDiscussed = __webpack_require__(690);
	
	var _MostDiscussed2 = _interopRequireDefault(_MostDiscussed);
	
	var _reactPureRenderShallowEqual = __webpack_require__(119);
	
	var _reactPureRenderShallowEqual2 = _interopRequireDefault(_reactPureRenderShallowEqual);
	
	var _decoratorsConnectToStores = __webpack_require__(161);
	
	var _decoratorsConnectToStores2 = _interopRequireDefault(_decoratorsConnectToStores);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var _GoalsPageScss = __webpack_require__(694);
	
	var _GoalsPageScss2 = _interopRequireDefault(_GoalsPageScss);
	
	var _utilsNeedLoadSubscribe = __webpack_require__(640);
	
	var _utilsNeedLoadSubscribe2 = _interopRequireDefault(_utilsNeedLoadSubscribe);
	
	var goalMenuItems = (0, _immutable.Map)({"interesting":"Рекомендации","all":"Новые","promise":"Цена слова","groups":"Группы","completed":"Завершенные"});
	var templateMenuItems = (0, _immutable.Map)({"interesting":"Отобранные","all":"Все"});
	
	var blocks = [function (_ref2) {
	  var flux = _ref2.flux;
	  return {
	    $$typeof: _typeofReactElement,
	    type: _Specials2['default'],
	    key: null,
	    ref: null,
	    props: _defaultProps(_Specials2['default'].defaultProps, {
	      flux: flux
	    }),
	    _owner: null
	  };
	}, function (_ref3) {
	  var flux = _ref3.flux;
	  var usersTop = _ref3.usersTop;
	  return {
	    $$typeof: _typeofReactElement,
	    type: _MostActive2['default'],
	    key: null,
	    ref: null,
	    props: _defaultProps(_MostActive2['default'].defaultProps, {
	      flux: flux,
	      initialData: usersTop
	    }),
	    _owner: null
	  };
	}, function (_ref4) {
	  var flux = _ref4.flux;
	  var goalsTop = _ref4.goalsTop;
	  return {
	    $$typeof: _typeofReactElement,
	    type: _MostDiscussed2['default'],
	    key: null,
	    ref: null,
	    props: _defaultProps(_MostDiscussed2['default'].defaultProps, {
	      flux: flux,
	      initialData: goalsTop
	    }),
	    _owner: null
	  };
	}];
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: _componentsSpinner2['default'],
	  key: null,
	  ref: null,
	  props: _defaultProps(_componentsSpinner2['default'].defaultProps, {}),
	  _owner: null
	};
	
	var GoalsPage = (function (_React$Component) {
	  _inherits(GoalsPage, _React$Component);
	
	  _createClass(GoalsPage, null, [{
	    key: 'propTypes',
	    value: {
	      showAdditionalBlocks: _react.PropTypes.bool.isRequired,
	      additionalBlocksPositions: _react.PropTypes.array,
	      loading: _react.PropTypes.bool.isRequired,
	      loaded: _react.PropTypes.bool.isRequired,
	      flux: _react.PropTypes.object.isRequired,
	      goals: _react.PropTypes.object.isRequired,
	      items: _react.PropTypes.object.isRequired,
	      filter: _react.PropTypes.object.isRequired,
	      initFilter: _react.PropTypes.object.isRequired,
	      categories: _react.PropTypes.object.isRequired,
	      currency: _react.PropTypes.object.isRequired,
	      isGuest: _react.PropTypes.bool,
	      usersTop: _react.PropTypes.array,
	      goalsTop: _react.PropTypes.array
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      additionalBlocksPositions: []
	    },
	    enumerable: true
	  }]);
	
	  function GoalsPage() {
	    var _this = this;
	
	    _classCallCheck(this, _GoalsPage);
	
	    _get(Object.getPrototypeOf(_GoalsPage.prototype), 'constructor', this).call(this);
	    this.handleNeedLoad = (0, _lodashFunctionThrottle2['default'])(function () {
	      if (!_this.props.loaded) {
	        _this.props.flux.getActions('goalsList').loadPage(_this.props.items.size);
	      }
	    }, 100);
	  }
	
	  _createClass(GoalsPage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      (0, _utilsNeedLoadSubscribe2['default'])(this.handleNeedLoad);
	      this.props.filter.lang = this.props.initFilter.lang;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!(0, _reactPureRenderShallowEqual2['default'])(this.props.filter, nextProps.filter)) {
	        (function () {
	          var _nextProps$filter = nextProps.filter;
	          var section = _nextProps$filter.section;
	          var sort = _nextProps$filter.sort;
	
	          var urlOptions = { section: section, sort: sort };
	
	          history.pushState(null, null, '' + location.origin + location.pathname + '?' + Object.keys(urlOptions).map(function (key) {
	            return [key, urlOptions[key]].join('=');
	          }).join('&'));
	        })();
	      }
	    }
	  }, {
	    key: 'handleMenuClick',
	    value: function handleMenuClick(item) {
	      var _props = this.props;
	      var flux = _props.flux;
	      var filter = _props.filter;
	
	      if (filter.section !== item && item !== 'groups') {
	        flux.getActions('goalsList').changeFilter('section', item);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props;
	      var filter = _props2.filter;
	      var flux = _props2.flux;
	      var loading = _props2.loading;
	      var categories = _props2.categories;
	
	      var goalsListActions = flux.getActions('goalsList');
	
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: _componentsSmartMenu2['default'],
	            key: null,
	            ref: null,
	            props: _defaultProps(_componentsSmartMenu2['default'].defaultProps, {
	              onItemClick: function (item, e) {
	                if (item !== 'groups') {
	                  e.preventDefault();
	                  _this2.handleMenuClick(item);
	                }
	              },
	              items: filter.list_type === 'goal' ? goalMenuItems : templateMenuItems,
	              additionals: filter.list_type === 'goal' ? ['completed'] : [],
	              urls: {
	                groups: '/goalGroup',
	                interesting: '/goal',
	                all: '/goal?section=all',
	                promise: '/goal?section=promise',
	                completed: '/goal?section=completed'
	              },
	              value: filter.section
	            }),
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: _componentsGoalsSearch2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_componentsGoalsSearch2['default'].defaultProps, {
	                  filter: filter,
	                  loading: loading,
	                  categories: categories,
	                  onReset: goalsListActions.resetFilter,
	                  onChange: goalsListActions.changeFilter
	                }),
	                _owner: null
	              }, this.renderList(), loading && {
	                $$typeof: _typeofReactElement,
	                type: 'div',
	                key: null,
	                ref: null,
	                props: {
	                  children: _ref,
	                  style: { textAlign: 'center' }
	                },
	                _owner: null
	              }],
	              className: 'content container'
	            },
	            _owner: null
	          }]
	        },
	        _owner: null
	      };
	    }
	  }, {
	    key: 'renderList',
	    value: function renderList() {
	      var _this3 = this;
	
	      var _props3 = this.props;
	      var items = _props3.items;
	      var flux = _props3.flux;
	      var showAdditionalBlocks = _props3.showAdditionalBlocks;
	      var filter = _props3.filter;
	      var isGuest = _props3.isGuest;
	      var currency = _props3.currency;
	      var additionalBlocksPositions = _props3.additionalBlocksPositions;
	
	      var goals = items.map(function (id) {
	        return _this3.props.goals.get(id);
	      });
	      var goalsActions = flux.getActions('goals');
	      var additionalBlocks = additionalBlocksPositions.reduce(function (memo, index, i) {
	        return _extends({}, memo, _defineProperty({}, index, blocks[i]));
	      }, {});
	
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [goals.map(function (goal, i) {
	            return [[showAdditionalBlocks && filter.section === 'interesting' && additionalBlocks[i] && additionalBlocks[i](_this3.props), {
	              $$typeof: _typeofReactElement,
	              type: _componentsGoalCard2['default'],
	              key: i,
	              ref: null,
	              props: _defaultProps(_componentsGoalCard2['default'].defaultProps, {
	                onLike: function () {
	                  return goalsActions.like(goal.get('id'), filter.list_type);
	                },
	                onSubscribe: function () {
	                  return goalsActions.subscribe(goal.get('id'));
	                },
	                onUnsubscribe: function () {
	                  return goalsActions.unsubscribe(goal.get('id'));
	                },
	                goal: goal,
	                isGuest: isGuest,
	                currency: currency,
	                type: filter.list_type
	              }),
	              _owner: null
	            }]];
	          }), {
	            $$typeof: _typeofReactElement,
	            type: _componentsGoalCardWrapper2['default'],
	            key: null,
	            ref: null,
	            props: _defaultProps(_componentsGoalCardWrapper2['default'].defaultProps, {
	              style: { visibility: 'hidden' }
	            }),
	            _owner: null
	          }],
	          className: (0, _GoalsPageScss2['default'])('list')
	        },
	        _owner: null
	      };
	    }
	  }]);
	
	  var _GoalsPage = GoalsPage;
	  GoalsPage = (0, _decoratorsConnectToStores2['default'])({
	    currency: function currency(_ref5) {
	      var state = _ref5.state;
	      return { currency: state };
	    },
	    categories: function categories(_ref6) {
	      var state = _ref6.state;
	      return { categories: state.categories };
	    },
	    goals: function goals(store) {
	      return store.state;
	    },
	    goalsList: function goalsList(store) {
	      return {
	        loaded: store.state.loaded,
	        loading: store.state.loading,
	        items: store.state.items, // .getGoals(),
	        filter: store.state.filter
	      };
	    }
	  })(GoalsPage) || GoalsPage;
	  GoalsPage = (0, _decoratorsWithStyles2['default'])(_GoalsPageScss2['default'])(GoalsPage) || GoalsPage;
	  return GoalsPage;
	})(_react2['default'].Component);
	
	exports['default'] = GoalsPage;
	module.exports = exports['default'];

/***/ }),

/***/ 646:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bemClassname = __webpack_require__(54);
	
	var _bemClassname2 = _interopRequireDefault(_bemClassname);
	
	var className = _bemClassname2['default'].bind(null, 'smart-menu');
	
	var SmartMenu = (function (_React$Component) {
		_inherits(SmartMenu, _React$Component);
	
		function SmartMenu() {
			_classCallCheck(this, SmartMenu);
	
			_get(Object.getPrototypeOf(SmartMenu.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(SmartMenu, [{
			key: 'handleClick',
			value: function handleClick(item, e) {
				this.props.onItemClick && this.props.onItemClick(item, e);
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props = this.props;
				var items = _props.items;
				var additionals = _props.additionals;
				var value = _props.value;
				var urls = _props.urls;
	
				return {
					$$typeof: _typeofReactElement,
					type: 'div',
					key: null,
					ref: null,
					props: {
						children: {
							$$typeof: _typeofReactElement,
							type: 'ul',
							key: null,
							ref: null,
							props: {
								children: items.map(function (label, key) {
									return {
										$$typeof: _typeofReactElement,
										type: 'li',
										key: key,
										ref: null,
										props: {
											children: _react2['default'].createElement(
												'a',
												_extends({
													className: className('link'),
													onClick: function (e) {
														return _this.handleClick(key, e);
													}
												}, urls[key] ? { href: urls[key] } : {}),
												label
											),
											className: className('item', { current: key === value, additional: additionals.indexOf(key) !== -1 })
										},
										_owner: null
									};
								}).toArray(),
								className: 'container ' + className('list')
							},
							_owner: null
						},
						className: className()
					},
					_owner: null
				};
			}
		}], [{
			key: 'propTypes',
			value: {
				items: _react2['default'].PropTypes.object,
				value: _react2['default'].PropTypes.string,
				additionals: _react2['default'].PropTypes.array,
				urls: _react2['default'].PropTypes.object,
				onItemClick: _react2['default'].PropTypes.func
			},
			enumerable: true
		}]);
	
		return SmartMenu;
	})(_react2['default'].Component);
	
	exports['default'] = SmartMenu;
	module.exports = exports['default'];

/***/ }),

/***/ 647:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(78);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _componentsIcon = __webpack_require__(53);
	
	var _componentsIcon2 = _interopRequireDefault(_componentsIcon);
	
	var _componentsLike = __webpack_require__(140);
	
	var _componentsLike2 = _interopRequireDefault(_componentsLike);
	
	var _componentsSubscribe = __webpack_require__(606);
	
	var _componentsSubscribe2 = _interopRequireDefault(_componentsSubscribe);
	
	var _componentsFormattedContent = __webpack_require__(112);
	
	var _componentsFormattedContent2 = _interopRequireDefault(_componentsFormattedContent);
	
	var _immutable = __webpack_require__(84);
	
	var _bemClassname = __webpack_require__(54);
	
	var _bemClassname2 = _interopRequireDefault(_bemClassname);
	
	var _uuid = __webpack_require__(123);
	
	var _uuid2 = _interopRequireDefault(_uuid);
	
	var _Wrapper = __webpack_require__(648);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _utilsLang = __webpack_require__(205);
	
	var className = _bemClassname2['default'].bind(null, 'card');
	
	var handlers = {};
	
	if (true) {
	  window.addEventListener('resize', function (e) {
	    Object.keys(handlers).forEach(function (key) {
	      return handlers[key](e);
	    });
	  });
	}
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: _componentsIcon2['default'],
	  key: null,
	  ref: null,
	  props: _defaultProps(_componentsIcon2['default'].defaultProps, {
	    type: 'user'
	  }),
	  _owner: null
	};
	var _ref2 = {
	  $$typeof: _typeofReactElement,
	  type: _componentsIcon2['default'],
	  key: null,
	  ref: null,
	  props: _defaultProps(_componentsIcon2['default'].defaultProps, {
	    type: 'pen'
	  }),
	  _owner: null
	};
	var _ref3 = {
	  $$typeof: _typeofReactElement,
	  type: _componentsIcon2['default'],
	  key: null,
	  ref: null,
	  props: _defaultProps(_componentsIcon2['default'].defaultProps, {
	    type: 'comment'
	  }),
	  _owner: null
	};
	
	var GoalCard = (function (_React$Component) {
	  _inherits(GoalCard, _React$Component);
	
	  function GoalCard() {
	    _classCallCheck(this, GoalCard);
	
	    _get(Object.getPrototypeOf(GoalCard.prototype), 'constructor', this).apply(this, arguments);
	
	    this.uuid = _uuid2['default'].v1();
	    this.state = {
	      cut: false
	    };
	  }
	
	  _createClass(GoalCard, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this = this;
	
	      this.handleResize = function () {
	        var descrWrapperRect = _this.refs.descrWrapper.getBoundingClientRect();
	        var descrRect = _reactDom2['default'].findDOMNode(_this.refs.descr).getBoundingClientRect();
	
	        _this.setState({
	          cut: descrWrapperRect.height < descrRect.height
	        });
	      };
	      handlers[this.uuid] = this.handleResize;
	      this.handleResize();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      delete handlers[this.uuid];
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _immutable.is)(this.props.goal, nextProps.goal) || nextState.cut !== this.state.cut;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var goal = _props.goal;
	      var _props$type = _props.type;
	      var type = _props$type === undefined ? 'goal' : _props$type;
	      var currency = _props.currency;
	      var wrapperSize = _props.wrapperSize;
	      var cut = this.state.cut;
	
	      return {
	        $$typeof: _typeofReactElement,
	        type: _Wrapper2['default'],
	        key: null,
	        ref: null,
	        props: _defaultProps(_Wrapper2['default'].defaultProps, {
	          children: [{
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: 'a',
	                key: null,
	                ref: null,
	                props: {
	                  children: {
	                    $$typeof: _typeofReactElement,
	                    type: 'div',
	                    key: null,
	                    ref: null,
	                    props: {
	                      children: [{
	                        $$typeof: _typeofReactElement,
	                        type: 'div',
	                        key: null,
	                        ref: null,
	                        props: {
	                          className: className('img-w', { empty: !goal.get('img') }),
	                          style: {
	                            backgroundColor: goal.get('imgBg'),
	                            backgroundImage: 'url(' + goal.get('img') + ')'
	                          }
	                        },
	                        _owner: null
	                      }, {
	                        $$typeof: _typeofReactElement,
	                        type: 'div',
	                        key: null,
	                        ref: null,
	                        props: {
	                          children: [_ref, ' ', goal.get('username')],
	                          className: className('progrs')
	                        },
	                        _owner: null
	                      }, {
	                        $$typeof: _typeofReactElement,
	                        type: 'ul',
	                        key: null,
	                        ref: null,
	                        props: {
	                          children: [{
	                            $$typeof: _typeofReactElement,
	                            type: 'li',
	                            key: null,
	                            ref: null,
	                            props: {
	                              children: [_ref2, ' ', goal.get('count_posts')],
	                              className: className('metric')
	                            },
	                            _owner: null
	                          }, {
	                            $$typeof: _typeofReactElement,
	                            type: 'li',
	                            key: null,
	                            ref: null,
	                            props: {
	                              children: [_ref3, ' ', goal.get('count_comments')],
	                              className: className('metric')
	                            },
	                            _owner: null
	                          }],
	                          className: className('metrics')
	                        },
	                        _owner: null
	                      }],
	                      className: className('cover-w')
	                    },
	                    _owner: null
	                  },
	                  href: goal.get('url'),
	                  className: className('cover')
	                },
	                _owner: null
	              }, {
	                $$typeof: _typeofReactElement,
	                type: 'div',
	                key: null,
	                ref: null,
	                props: {
	                  children: [{
	                    $$typeof: _typeofReactElement,
	                    type: 'a',
	                    key: null,
	                    ref: null,
	                    props: {
	                      children: [{
	                        $$typeof: _typeofReactElement,
	                        type: 'p',
	                        key: null,
	                        ref: null,
	                        props: {
	                          children: goal.get('category_name'),
	                          className: className('cat')
	                        },
	                        _owner: null
	                      }, {
	                        $$typeof: _typeofReactElement,
	                        type: 'h3',
	                        key: null,
	                        ref: null,
	                        props: {
	                          children: [{
	                            $$typeof: _typeofReactElement,
	                            type: 'span',
	                            key: null,
	                            ref: null,
	                            props: {
	                              dangerouslySetInnerHTML: { __html: goal.get('name') }
	                            },
	                            _owner: null
	                          }, goal.get('status') === 'failed' && {
	                            $$typeof: _typeofReactElement,
	                            type: _componentsIcon2['default'],
	                            key: null,
	                            ref: null,
	                            props: _defaultProps(_componentsIcon2['default'].defaultProps, {
	                              type: 'fail',
	                              className: className('titleIcon')
	                            }),
	                            _owner: null
	                          }, goal.get('status') === 'successful' && {
	                            $$typeof: _typeofReactElement,
	                            type: _componentsIcon2['default'],
	                            key: null,
	                            ref: null,
	                            props: _defaultProps(_componentsIcon2['default'].defaultProps, {
	                              type: 'success',
	                              className: className('titleIcon')
	                            }),
	                            _owner: null
	                          }],
	                          className: className('title', [goal.get('status')])
	                        },
	                        _owner: null
	                      }],
	                      href: goal.get('url'),
	                      className: className('link', ['inline'])
	                    },
	                    _owner: null
	                  }, _react2['default'].createElement(
	                    'div',
	                    { className: className('descr', { cut: cut }), ref: 'descrWrapper' },
	                    _react2['default'].createElement(
	                      _componentsFormattedContent2['default'],
	                      { ref: 'descr' },
	                      goal.get('descr_short')
	                    )
	                  )],
	                  className: className('w')
	                },
	                _owner: null
	              }],
	              className: className('body')
	            },
	            _owner: null
	          }, {
	            $$typeof: _typeofReactElement,
	            type: 'footer',
	            key: null,
	            ref: null,
	            props: {
	              children: [goal.get('is_own') === 0 && type === 'goal' && {
	                $$typeof: _typeofReactElement,
	                type: _componentsSubscribe2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_componentsSubscribe2['default'].defaultProps, {
	                  subscribed: parseInt(goal.get('subscription'), 10) > 0,
	                  counter: goal.get('count_subscriptions'),
	                  fastSignupParams: {
	                    subscribe_to_goal: goal.get('id')
	                  },
	                  onClick: parseInt(goal.get('subscription'), 10) > 0 ? this.props.onUnsubscribe : this.props.onSubscribe
	                }),
	                _owner: null
	              }, goal.get('is_own') > 0 && type === 'goal' && {
	                $$typeof: _typeofReactElement,
	                type: 'span',
	                key: null,
	                ref: null,
	                props: {
	                  children: (0, _utilsLang.declension)("%d подписчик|%d подписчика|%d подписчиков", goal.get('count_subscriptions')),
	                  style: { color: '#8D95A0' }
	                },
	                _owner: null
	              }, type === 'template' && {
	                $$typeof: _typeofReactElement,
	                type: 'span',
	                key: null,
	                ref: null,
	                props: {
	                  dangerouslySetInnerHTML: {
	                    __html: goal.get('price') === '0.00' ? "Бесплатный" : goal.get('price') + ' ' + currency.sign
	                  }
	                },
	                _owner: null
	              }, {
	                $$typeof: _typeofReactElement,
	                type: _componentsLike2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_componentsLike2['default'].defaultProps, {
	                  liked: !!Number(goal.get('liked')),
	                  disabled: goal.get('is_own'),
	                  counter: parseInt(goal.get('rating'), 10),
	                  onClick: this.props.onLike,
	                  share: true,
	                  fastSignupParams: {
	                    Rating: {
	                      obj_type: 'goal',
	                      obj_id: goal.get('id')
	                    }
	                  },
	                  fastSignupPosition: 'right',
	                  shareOptions: {
	                    url: goal.get('share_url'),
	                    descr: goal.get('share_descr'),
	                    img: goal.get('share_image')
	                  }
	                }),
	                _owner: null
	              }],
	              className: className('footer', ['goal'])
	            },
	            _owner: null
	          }],
	          size: wrapperSize,
	          className: className(['with-footer', 'full'])
	        }),
	        _owner: null
	      };
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      goal: _react.PropTypes.object.isRequired,
	      currency: _react.PropTypes.object.isRequired,
	      isGuest: _react.PropTypes.bool.isRequired,
	      onLike: _react.PropTypes.func.isRequired,
	      onSubscribe: _react.PropTypes.func.isRequired,
	      type: _react.PropTypes.oneOf(['template', 'goal']),
	      onUnsubscribe: _react.PropTypes.func.isRequired,
	      wrapperSize: _react.PropTypes.oneOf(['1', '2', '3', '1/2'])
	    },
	    enumerable: true
	  }]);
	
	  return GoalCard;
	})(_react2['default'].Component);
	
	exports['default'] = GoalCard;
	module.exports = exports['default'];

/***/ }),

/***/ 648:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsCard = __webpack_require__(94);
	
	var _componentsCard2 = _interopRequireDefault(_componentsCard);
	
	var _WrapperScss = __webpack_require__(649);
	
	var _WrapperScss2 = _interopRequireDefault(_WrapperScss);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var Wrapper = (function (_React$Component) {
		_inherits(Wrapper, _React$Component);
	
		function Wrapper() {
			_classCallCheck(this, _Wrapper);
	
			_get(Object.getPrototypeOf(_Wrapper.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(Wrapper, [{
			key: 'render',
			value: function render() {
				var _props = this.props;
				var size = _props.size;
				var _props$className = _props.className;
				var className = _props$className === undefined ? '' : _props$className;
	
				var rest = _objectWithoutProperties(_props, ['size', 'className']);
	
				return _react2['default'].createElement(_componentsCard2['default'], _extends({
					className: className + ' ' + (0, _WrapperScss2['default'])('main', _defineProperty({}, size.replace('/', '-'), true))
				}, rest));
			}
		}], [{
			key: 'propTypes',
			value: {
				size: _react.PropTypes.oneOf(['1', '2', '3', '1/2']),
				className: _react.PropTypes.string
			},
			enumerable: true
		}, {
			key: 'defaultProps',
			value: {
				size: '1'
			},
			enumerable: true
		}]);
	
		var _Wrapper = Wrapper;
		Wrapper = (0, _decoratorsWithStyles2['default'])(_WrapperScss2['default'])(Wrapper) || Wrapper;
		return Wrapper;
	})(_react2['default'].Component);
	
	exports['default'] = Wrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 649:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(650);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 650:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(651);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./Wrapper.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./Wrapper.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 651:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._1aHPegpHZ_{box-sizing:border-box;margin-bottom:20px}.McBImsZ9Mg{width:calc(33.3336% - 13.333333333333334px)!important}._39Lugke9ij{width:calc(66.66667% - 10px)!important}._1Z3oAlyuxl{width:calc(50% - 10px)!important}.BtJZv1Vvx-{width:100%!important}._1aHPegpHZ_._1aHPegpHZ_._1aHPegpHZ_{margin-left:0!important}@media screen and (max-width:1100px){.McBImsZ9Mg{width:calc(50% - 10px)!important}._39Lugke9ij{width:100%!important}}@media (max-width:850px){.McBImsZ9Mg{width:100%!important}}", ""]);
	
	// exports
	exports.locals = {
		"main": "_1aHPegpHZ_",
		"main--1": "McBImsZ9Mg",
		"main--2": "_39Lugke9ij",
		"main--1-2": "_1Z3oAlyuxl",
		"main--3": "BtJZv1Vvx-"
	};

/***/ }),

/***/ 652:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(653);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _immutable = __webpack_require__(84);
	
	var _componentsTextInput = __webpack_require__(175);
	
	var _componentsTextInput2 = _interopRequireDefault(_componentsTextInput);
	
	var _componentsSelectInput = __webpack_require__(136);
	
	var _componentsSelectInput2 = _interopRequireDefault(_componentsSelectInput);
	
	var _componentsLanguageSelector = __webpack_require__(654);
	
	var _componentsLanguageSelector2 = _interopRequireDefault(_componentsLanguageSelector);
	
	var _componentsCard = __webpack_require__(94);
	
	var _componentsCard2 = _interopRequireDefault(_componentsCard);
	
	var _componentsButton = __webpack_require__(93);
	
	var _componentsButton2 = _interopRequireDefault(_componentsButton);
	
	var _GoalsSearchScss = __webpack_require__(658);
	
	var _GoalsSearchScss2 = _interopRequireDefault(_GoalsSearchScss);
	
	var _TabFilter = __webpack_require__(662);
	
	var _TabFilter2 = _interopRequireDefault(_TabFilter);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var helpItems = (0, _immutable.Map)({"all":"Помощь","both_help":"Все","help":"Нужна помощь","partner":"Ищу партнера"});
	var statusItems = (0, _immutable.Map)({"all":"Все","active":"Активные","successful":"Успешные","failed":"Проваленные"});
	var showItems = (0, _immutable.Map)({"all":"Все","promise":"С ценой слова","help":"Нужна помощь","partner":"Ищу партнера"});
	var templateTypeItems = (0, _immutable.Map)({"":"Все","free":"Бесплатные","paid":"Платные"});
	var sortItems = (0, _immutable.Map)({"new":"Без сортировки","discussed":"Самые обсуждаемые","best_day":"Лучшие за сутки","best_week":"Лучшие за неделю","best_month":"Лучшие за месяц","best_alltime":"Лучшие за все время"});
	
	var _ref = {
		$$typeof: _typeofReactElement,
		type: 'div',
		key: null,
		ref: null,
		props: {
			className: 'clear'
		},
		_owner: null
	};
	
	var GoalsSearch = (function (_React$Component) {
		_inherits(GoalsSearch, _React$Component);
	
		_createClass(GoalsSearch, null, [{
			key: 'propTypes',
			value: {
				onChange: _react.PropTypes.func.isRequired,
				filter: _react.PropTypes.object,
				flux: _react.PropTypes.object,
				categories: _react.PropTypes.object,
				loading: _react.PropTypes.bool,
				onReset: _react.PropTypes.func.isRequired
			},
			enumerable: true
		}]);
	
		function GoalsSearch(props) {
			_classCallCheck(this, _GoalsSearch);
	
			_get(Object.getPrototypeOf(_GoalsSearch.prototype), 'constructor', this).call(this, props);
	
			this.state = {
				focused: false,
				expanded: false,
				progress: 0
			};
		}
	
		_createClass(GoalsSearch, [{
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _state = this.state;
				var progress = _state.progress;
				var expanded = _state.expanded;
				var _props = this.props;
				var filter = _props.filter;
				var categories = _props.categories;
	
				return {
					$$typeof: _typeofReactElement,
					type: _componentsCard2['default'],
					key: null,
					ref: null,
					props: _defaultProps(_componentsCard2['default'].defaultProps, {
						children: [_react2['default'].createElement('div', {
							ref: 'progress',
							className: (0, _GoalsSearchScss2['default'])('progress'),
							style: {
								opacity: progress === 0 ? 0 : 1,
								width: progress * 100 + '%'
							}
						}), {
							$$typeof: _typeofReactElement,
							type: 'div',
							key: null,
							ref: null,
							props: {
								children: [{
									$$typeof: _typeofReactElement,
									type: _componentsTextInput2['default'],
									key: null,
									ref: null,
									props: _defaultProps(_componentsTextInput2['default'].defaultProps, {
										className: (0, _GoalsSearchScss2['default'])('input'),
										onFocus: function () {
											return _this.expand();
										},
										onChange: function (v) {
											return _this.handleSearchChange('name', v);
										},
										value: filter.name
									}),
									_owner: null
								}, {
									$$typeof: _typeofReactElement,
									type: 'div',
									key: null,
									ref: null,
									props: {
										children: {
											$$typeof: _typeofReactElement,
											type: _componentsLanguageSelector2['default'],
											key: null,
											ref: null,
											props: _defaultProps(_componentsLanguageSelector2['default'].defaultProps, {
												title: filter.list_type === 'goal' ? "Язык целей" : "Язык шаблонов",
												value: filter.lang || [],
												onChange: function (v) {
													return _this.handleSearchChange('lang', v);
												}
											}),
											_owner: null
										},
										className: (0, _GoalsSearchScss2['default'])('lang')
									},
									_owner: null
								}, {
									$$typeof: _typeofReactElement,
									type: 'div',
									key: null,
									ref: null,
									props: {
										children: [filter.list_type === 'template' && {
											$$typeof: _typeofReactElement,
											type: 'div',
											key: null,
											ref: null,
											props: {
												children: {
													$$typeof: _typeofReactElement,
													type: _componentsSelectInput2['default'],
													key: null,
													ref: null,
													props: _defaultProps(_componentsSelectInput2['default'].defaultProps, {
														mods: ['transparent'],
														items: templateTypeItems,
														value: filter.type,
														onChange: function (v) {
															return _this.handleSearchChange('type', v);
														}
													}),
													_owner: null
												},
												className: (0, _GoalsSearchScss2['default'])('filter')
											},
											_owner: null
										}, !expanded && {
											$$typeof: _typeofReactElement,
											type: 'div',
											key: null,
											ref: null,
											props: {
												children: [filter.list_type === 'goal' && {
													$$typeof: _typeofReactElement,
													type: 'div',
													key: null,
													ref: null,
													props: {
														children: {
															$$typeof: _typeofReactElement,
															type: _componentsSelectInput2['default'],
															key: null,
															ref: null,
															props: _defaultProps(_componentsSelectInput2['default'].defaultProps, {
																mods: ['transparent'],
																items: categories.reduce(function (memo, category) {
																	return memo.set(category.get('id'), category.get('name'));
																}, (0, _immutable.OrderedMap)()),
																value: filter.category,
																onChange: function (v) {
																	return _this.handleSearchChange('category', v);
																}
															}),
															_owner: null
														},
														className: (0, _GoalsSearchScss2['default'])('filter')
													},
													_owner: null
												}, filter.list_type === 'goal' && {
													$$typeof: _typeofReactElement,
													type: 'div',
													key: null,
													ref: null,
													props: {
														children: {
															$$typeof: _typeofReactElement,
															type: _componentsSelectInput2['default'],
															key: null,
															ref: null,
															props: _defaultProps(_componentsSelectInput2['default'].defaultProps, {
																mods: ['transparent'],
																items: sortItems,
																value: filter.sort,
																onChange: function (v) {
																	return _this.handleSearchChange('sort', v);
																}
															}),
															_owner: null
														},
														className: (0, _GoalsSearchScss2['default'])('filter')
													},
													_owner: null
												}, filter.list_type === 'goal' && {
													$$typeof: _typeofReactElement,
													type: 'div',
													key: null,
													ref: null,
													props: {
														children: {
															$$typeof: _typeofReactElement,
															type: _componentsSelectInput2['default'],
															key: null,
															ref: null,
															props: _defaultProps(_componentsSelectInput2['default'].defaultProps, {
																mods: ['transparent'],
																items: helpItems,
																value: filter.help,
																onChange: function (v) {
																	return _this.handleSearchChange('help', v);
																}
															}),
															_owner: null
														},
														className: (0, _GoalsSearchScss2['default'])('filter')
													},
													_owner: null
												}]
											},
											_owner: null
										}]
									},
									_owner: null
								}],
								className: (0, _GoalsSearchScss2['default'])('top', [filter.list_type])
							},
							_owner: null
						}, {
							$$typeof: _typeofReactElement,
							type: _reactAddonsCssTransitionGroup2['default'],
							key: null,
							ref: null,
							props: _defaultProps(_reactAddonsCssTransitionGroup2['default'].defaultProps, {
								children: expanded && filter.list_type === 'goal' && {
									$$typeof: _typeofReactElement,
									type: 'div',
									key: null,
									ref: null,
									props: {
										children: [{
											$$typeof: _typeofReactElement,
											type: 'section',
											key: null,
											ref: null,
											props: {
												children: [{
													$$typeof: _typeofReactElement,
													type: 'label',
													key: null,
													ref: null,
													props: {
														children: "Показать",
														className: (0, _GoalsSearchScss2['default'])('lbl')
													},
													_owner: null
												}, {
													$$typeof: _typeofReactElement,
													type: _TabFilter2['default'],
													key: null,
													ref: null,
													props: _defaultProps(_TabFilter2['default'].defaultProps, {
														items: showItems,
														value: filter.section,
														onChange: function (v) {
															return _this.handleSearchChange('section', v);
														}
													}),
													_owner: null
												}],
												className: (0, _GoalsSearchScss2['default'])('col', ['main'])
											},
											_owner: null
										}, {
											$$typeof: _typeofReactElement,
											type: 'section',
											key: null,
											ref: null,
											props: {
												children: [{
													$$typeof: _typeofReactElement,
													type: 'label',
													key: null,
													ref: null,
													props: {
														children: "Категория",
														className: (0, _GoalsSearchScss2['default'])('lbl')
													},
													_owner: null
												}, {
													$$typeof: _typeofReactElement,
													type: _componentsSelectInput2['default'],
													key: null,
													ref: null,
													props: _defaultProps(_componentsSelectInput2['default'].defaultProps, {
														mods: ['transparent'],
														items: categories.reduce(function (memo, category) {
															return memo.set(category.get('id'), category.get('name'));
														}, (0, _immutable.OrderedMap)()),
														value: filter.category,
														onChange: function (v) {
															return _this.handleSearchChange('category', v);
														}
													}),
													_owner: null
												}],
												className: (0, _GoalsSearchScss2['default'])('col')
											},
											_owner: null
										}, {
											$$typeof: _typeofReactElement,
											type: 'section',
											key: null,
											ref: null,
											props: {
												children: [{
													$$typeof: _typeofReactElement,
													type: 'label',
													key: null,
													ref: null,
													props: {
														children: "Сортировка",
														className: (0, _GoalsSearchScss2['default'])('lbl')
													},
													_owner: null
												}, {
													$$typeof: _typeofReactElement,
													type: _TabFilter2['default'],
													key: null,
													ref: null,
													props: _defaultProps(_TabFilter2['default'].defaultProps, {
														items: sortItems,
														value: filter.sort,
														onChange: function (v) {
															return _this.handleSearchChange('sort', v);
														}
													}),
													_owner: null
												}],
												className: (0, _GoalsSearchScss2['default'])('col', ['main'])
											},
											_owner: null
										}, {
											$$typeof: _typeofReactElement,
											type: 'section',
											key: null,
											ref: null,
											props: {
												className: (0, _GoalsSearchScss2['default'])('col')
											},
											_owner: null
										}, {
											$$typeof: _typeofReactElement,
											type: 'section',
											key: null,
											ref: null,
											props: {
												children: [{
													$$typeof: _typeofReactElement,
													type: 'label',
													key: null,
													ref: null,
													props: {
														children: "Статус",
														className: (0, _GoalsSearchScss2['default'])('lbl')
													},
													_owner: null
												}, {
													$$typeof: _typeofReactElement,
													type: _TabFilter2['default'],
													key: null,
													ref: null,
													props: _defaultProps(_TabFilter2['default'].defaultProps, {
														items: statusItems,
														value: filter.status || 'all',
														onChange: function (v) {
															return _this.handleSearchChange('status', v);
														}
													}),
													_owner: null
												}],
												className: (0, _GoalsSearchScss2['default'])('col', ['main'])
											},
											_owner: null
										}, {
											$$typeof: _typeofReactElement,
											type: 'section',
											key: null,
											ref: null,
											props: {
												className: (0, _GoalsSearchScss2['default'])('col')
											},
											_owner: null
										}, _ref, {
											$$typeof: _typeofReactElement,
											type: 'div',
											key: null,
											ref: null,
											props: {
												children: {
													$$typeof: _typeofReactElement,
													type: _componentsButton2['default'],
													key: null,
													ref: null,
													props: _defaultProps(_componentsButton2['default'].defaultProps, {
														children: "Закрыть",
														theme: 'gray',
														onClick: function () {
															_this.wrap();_this.props.onReset;
														}
													}),
													_owner: null
												},
												className: (0, _GoalsSearchScss2['default'])('clear')
											},
											_owner: null
										}],
										className: (0, _GoalsSearchScss2['default'])('expanded')
									},
									_owner: null
								},
								transitionName: 't-search-slide',
								transitionEnterTimeout: 200,
								transitionLeaveTimeout: 200
							}),
							_owner: null
						}],
						className: (0, _GoalsSearchScss2['default'])('main')
					}),
					_owner: null
				};
			}
		}, {
			key: 'handleSearchChange',
			value: function handleSearchChange(key, value) {
				this.props.onChange(key, value);
			}
		}, {
			key: 'expand',
			value: function expand() {
				this.setState({ expanded: true });
			}
		}, {
			key: 'wrap',
			value: function wrap() {
				this.setState({ expanded: false });
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				// ends up progress
				this.refs.progress.addEventListener('transitionend', function () {
					return _this2.setState({ progress: _this2.state.progress === 1 ? 0 : _this2.state.progress });
				});
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps) {
				// faking progress
				if (nextProps.loading && !this.props.loading) {
					this.setState({ progress: 0.7 });
				} else if (!nextProps.loading && this.props.loading) {
					this.setState({ progress: 1 });
				}
			}
		}]);
	
		var _GoalsSearch = GoalsSearch;
		GoalsSearch = (0, _decoratorsWithStyles2['default'])(_GoalsSearchScss2['default'])(GoalsSearch) || GoalsSearch;
		return GoalsSearch;
	})(_react2['default'].Component);
	
	exports['default'] = GoalsSearch;
	module.exports = exports['default'];

/***/ }),

/***/ 653:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = (__webpack_require__(6))(239);

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsIcon = __webpack_require__(53);
	
	var _componentsIcon2 = _interopRequireDefault(_componentsIcon);
	
	var _componentsCheckable = __webpack_require__(98);
	
	var _componentsCheckable2 = _interopRequireDefault(_componentsCheckable);
	
	// import outClick from 'decorators/outClick';
	
	var _LanguageSelectorScss = __webpack_require__(655);
	
	var _LanguageSelectorScss2 = _interopRequireDefault(_LanguageSelectorScss);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var options = {"ru":"Русский","en":"English","uk":"Українська","es":"Español"};
	
	var _ref = {
		$$typeof: _typeofReactElement,
		type: _componentsIcon2['default'],
		key: null,
		ref: null,
		props: _defaultProps(_componentsIcon2['default'].defaultProps, {
			type: 'settings'
		}),
		_owner: null
	};
	
	// @outClick(component => component.setState({ expanded: false }))
	
	var LanguageSelector = (function (_React$Component) {
		_inherits(LanguageSelector, _React$Component);
	
		function LanguageSelector() {
			_classCallCheck(this, _LanguageSelector);
	
			_get(Object.getPrototypeOf(_LanguageSelector.prototype), 'constructor', this).apply(this, arguments);
	
			this.state = {
				expanded: false
			};
		}
	
		_createClass(LanguageSelector, [{
			key: 'handleChange',
			value: function handleChange(key, checked) {
				var _props = this.props;
				var value = _props.value;
				var onChange = _props.onChange;
	
				if (checked) {
					onChange([].concat(_toConsumableArray(value), [key]));
				} else {
					onChange(value.filter(function (v) {
						return v !== key;
					}));
				}
			}
		}, {
			key: 'render',
			value: function render() {
				var _this = this;
	
				var _props2 = this.props;
				var value = _props2.value;
				var _props2$title = _props2.title;
				var title = _props2$title === undefined ? '' : _props2$title;
				var expanded = this.state.expanded;
	
				return {
					$$typeof: _typeofReactElement,
					type: 'div',
					key: null,
					ref: null,
					props: {
						children: [{
							$$typeof: _typeofReactElement,
							type: 'a',
							key: null,
							ref: null,
							props: {
								children: _ref,
								className: (0, _LanguageSelectorScss2['default'])('button', { expanded: expanded }),
								onClick: function () {
									return _this.setState({ expanded: !expanded });
								}
							},
							_owner: null
						}, expanded && {
							$$typeof: _typeofReactElement,
							type: 'div',
							key: null,
							ref: null,
							props: {
								children: [{
									$$typeof: _typeofReactElement,
									type: 'h5',
									key: null,
									ref: null,
									props: {
										children: title,
										className: (0, _LanguageSelectorScss2['default'])('title')
									},
									_owner: null
								}, Object.keys(options).map(function (key) {
									return {
										$$typeof: _typeofReactElement,
										type: 'div',
										key: key,
										ref: null,
										props: {
											children: {
												$$typeof: _typeofReactElement,
												type: _componentsCheckable2['default'],
												key: null,
												ref: null,
												props: _defaultProps(_componentsCheckable2['default'].defaultProps, {
													children: options[key],
													type: 'checkbox',
													checked: value.indexOf(key) > -1,
													onChange: function (checked) {
														return _this.handleChange(key, checked);
													}
												}),
												_owner: null
											},
											className: (0, _LanguageSelectorScss2['default'])('item')
										},
										_owner: null
									};
								})],
								className: (0, _LanguageSelectorScss2['default'])('list')
							},
							_owner: null
						}],
						className: (0, _LanguageSelectorScss2['default'])('main')
					},
					_owner: null
				};
			}
		}], [{
			key: 'propTypes',
			value: {
				value: _react.PropTypes.arrayOf(_react.PropTypes.string).isRequired,
				onChange: _react.PropTypes.func.isRequired,
				title: _react.PropTypes.string
			},
			enumerable: true
		}]);
	
		var _LanguageSelector = LanguageSelector;
		LanguageSelector = (0, _decoratorsWithStyles2['default'])(_LanguageSelectorScss2['default'])(LanguageSelector) || LanguageSelector;
		return LanguageSelector;
	})(_react2['default'].Component);
	
	exports['default'] = LanguageSelector;
	module.exports = exports['default'];

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(656);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(657);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./LanguageSelector.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./LanguageSelector.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._3ljb6lrdv1{position:relative}._2ldI6dZhv5{-webkit-user-select:none;display:block;padding:7px 8px;cursor:pointer;color:#959fad;border-radius:4px}._1KrCKDjDsL,._2ldI6dZhv5:hover{color:#fff;background-color:#ffcc4d}._1KrCKDjDsL{border-radius:4px 4px 0 0}.kCQwxKgesn{position:absolute;z-index:2;top:100%;right:0;width:130px;padding:10px;background-color:#ffcc4d;border-radius:4px 0 4px 4px}._2DisQOw69N{font-size:9pt;font-weight:700;letter-spacing:1px;text-transform:uppercase}._21c2P5vP3U{font-weight:700;margin-top:5px}", ""]);
	
	// exports
	exports.locals = {
		"main": "_3ljb6lrdv1",
		"button": "_2ldI6dZhv5",
		"button--expanded": "_1KrCKDjDsL",
		"list": "kCQwxKgesn",
		"title": "_2DisQOw69N",
		"item": "_21c2P5vP3U"
	};

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(659);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(660);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./GoalsSearch.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./GoalsSearch.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._2xNmE6DmmZ{padding:10px 20px}._2xNmE6DmmZ:after{content:'';display:block;clear:both}@media (max-width:850px){._2xNmE6DmmZ{padding:10px}}.Z2P6tHsUIN{width:100%;padding-top:25px}._2sTkbKI-Oe{float:left;box-sizing:border-box;width:28%;margin-left:2%}._2rmhO4emga{width:70%;margin-left:0;padding-right:25px}._2rmhO4emga:not(:first-child){padding-top:15px;border-top:1px solid #dedfe3}._2rmhO4emga:not(:first-child)+._2sTkbKI-Oe{padding-top:15px}@media (max-width:850px){._2sTkbKI-Oe{width:100%;float:none;margin-left:0}}._2xcYyb-p6_{width:270px;margin-top:0!important;padding-left:30px!important;background-position:10px 45%!important;background-image:url(" + __webpack_require__(661) + ");background-repeat:no-repeat}._2xcYyb-p6_+._2xcYyb-p6_{margin-left:10px}.BYzldXFa7m{float:right;text-align:right}._1OClUKE1CF{font-size:9pt;font-weight:700;text-transform:uppercase}._1oqjprck1U{display:inline-block;text-align:left;vertical-align:middle}._2wyeegZqUA{width:100%;margin-top:5px;padding:10px 0 5px;text-align:center;border-top:1px solid #dedfe3}._3IbEYGcJ_z{position:absolute;top:-2px;left:0;width:0;height:2px;background:#2ab8d5;transition:width 1s}.t-search-slide-enter{max-height:0;overflow:hidden}.t-search-slide-enter-active{max-height:300px;transition:max-height .2s}.t-search-slide-leave{max-height:300px;overflow:hidden}.t-search-slide-leave-active{max-height:0;transition:max-height .2s}._3mwp1IjZ6M{position:relative;padding-right:40px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between}@media (max-width:850px){._3mwp1IjZ6M{padding-right:0}._2yHzxWtmwk{display:block}._2yHzxWtmwk ._1oqjprck1U{margin-left:0;margin-top:10px}._3mwp1IjZ6M ._2xcYyb-p6_,._3mwp1IjZ6M .form__inp-w{width:100%}}@media (max-width:850px) and (max-width:850px){._3mwp1IjZ6M ._2xcYyb-p6_,._3mwp1IjZ6M .form__inp-w{width:calc(100% - 20px)}}.UVOFFzs-KW{position:absolute;top:0;right:0}", ""]);
	
	// exports
	exports.locals = {
		"main": "_2xNmE6DmmZ",
		"expanded": "Z2P6tHsUIN",
		"col": "_2sTkbKI-Oe",
		"col--main": "_2rmhO4emga",
		"input": "_2xcYyb-p6_",
		"sort": "BYzldXFa7m",
		"lbl": "_1OClUKE1CF",
		"filter": "_1oqjprck1U",
		"clear": "_2wyeegZqUA",
		"progress": "_3IbEYGcJ_z",
		"top": "_3mwp1IjZ6M",
		"top--goal": "_2yHzxWtmwk",
		"lang": "UVOFFzs-KW"
	};

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAANCAYAAABy6+R8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAARFJREFUeNqE0r9LQlEYxvFb3ArEJcilRPB/CHFqcA1zaIj8I9pqcRDMQUF00j1zcEooaIlaopz7MTTW4CgRQoMtft94DhzkWi98ON4fj+ec956lVqcbqDZwjALS+MQDGhgGXi1r3MYLTvCDga53FSz5oVAzXGMVe7jynm+hhyo+9Pt3JltSAsW5gNVIf/SOOlZcyPbwpNmiaoI2NpFxIdv0W/B3PWtMupB1af2fUELjtwtZd3a06UV1iCkeXaiJNZwjHhE4UusvMHYtt5nKqKghHbzqUxwgr7B1MYe7UDdO1daaTkDg7cFWsI+YPkk+9F6wh31kkcKXjo8t6QyXCnbDufXbEbqP2NetlmkH9WYmwAAVnTiOo+/ZXAAAAABJRU5ErkJggg=="

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TabFilterScss = __webpack_require__(663);
	
	var _TabFilterScss2 = _interopRequireDefault(_TabFilterScss);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var TabFilter = (function (_React$Component) {
		_inherits(TabFilter, _React$Component);
	
		function TabFilter() {
			_classCallCheck(this, _TabFilter);
	
			_get(Object.getPrototypeOf(_TabFilter.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(TabFilter, [{
			key: 'render',
			value: function render() {
				var _props = this.props;
				var items = _props.items;
				var value = _props.value;
				var _props$className = _props.className;
				var className = _props$className === undefined ? '' : _props$className;
				var onChange = _props.onChange;
	
				return {
					$$typeof: _typeofReactElement,
					type: 'div',
					key: null,
					ref: null,
					props: {
						children: {
							$$typeof: _typeofReactElement,
							type: 'div',
							key: null,
							ref: null,
							props: {
								children: items.map(function (label, itemValue) {
									return {
										$$typeof: _typeofReactElement,
										type: 'label',
										key: itemValue,
										ref: null,
										props: {
											children: [{
												$$typeof: _typeofReactElement,
												type: 'input',
												key: null,
												ref: null,
												props: {
													type: 'radio',
													checked: itemValue === value,
													className: (0, _TabFilterScss2['default'])('inp'),
													onChange: function () {
														return onChange(itemValue);
													}
												},
												_owner: null
											}, {
												$$typeof: _typeofReactElement,
												type: 'span',
												key: null,
												ref: null,
												props: {
													children: label,
													className: (0, _TabFilterScss2['default'])('lbl')
												},
												_owner: null
											}],
											className: (0, _TabFilterScss2['default'])('item')
										},
										_owner: null
									};
								}).toArray(),
								className: (0, _TabFilterScss2['default'])('items')
							},
							_owner: null
						},
						className: className + ' ' + (0, _TabFilterScss2['default'])('main')
					},
					_owner: null
				};
			}
		}], [{
			key: 'propTypes',
			value: {
				items: _react.PropTypes.object.isRequired,
				value: _react.PropTypes.string.isRequired,
				onChange: _react.PropTypes.func,
				className: _react.PropTypes.string
			},
			enumerable: true
		}]);
	
		var _TabFilter = TabFilter;
		TabFilter = (0, _decoratorsWithStyles2['default'])(_TabFilterScss2['default'])(TabFilter) || TabFilter;
		return TabFilter;
	})(_react2['default'].Component);
	
	exports['default'] = TabFilter;
	module.exports = exports['default'];

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(664);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(665);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./TabFilter.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./TabFilter.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._281YyJDm7-:first-child{padding-top:0}._281YyJDm7-:last-child{border-bottom:none}._1IiuOyMD7V{padding-bottom:15px}._1IiuOyMD7V:after{content:'';display:block;clear:both}._2b-cgkem0f{display:block;float:left;margin-bottom:-5px;padding:5px 0;cursor:pointer}._2b-cgkem0f:first-child{padding-left:0}._3hCEZ4CDOZ{font-size:9pt;display:block;padding:5px 10px;border-radius:6px}.pffYYFOdqf{position:absolute;left:-9999px;opacity:0}.pffYYFOdqf:checked+._3hCEZ4CDOZ{background-color:#ffcc4d}", ""]);
	
	// exports
	exports.locals = {
		"main": "_281YyJDm7-",
		"items": "_1IiuOyMD7V",
		"item": "_2b-cgkem0f",
		"lbl": "_3hCEZ4CDOZ",
		"inp": "pffYYFOdqf"
	};

/***/ }),

/***/ 666:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(83);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _reactAddonsCssTransitionGroup = __webpack_require__(653);
	
	var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);
	
	var _componentsCardHeader = __webpack_require__(667);
	
	var _componentsCardHeader2 = _interopRequireDefault(_componentsCardHeader);
	
	var _componentsSpecialGoalCard = __webpack_require__(671);
	
	var _componentsSpecialGoalCard2 = _interopRequireDefault(_componentsSpecialGoalCard);
	
	var _componentsGoalCardWrapper = __webpack_require__(648);
	
	var _componentsGoalCardWrapper2 = _interopRequireDefault(_componentsGoalCardWrapper);
	
	var _decoratorsConnectToStores = __webpack_require__(161);
	
	var _decoratorsConnectToStores2 = _interopRequireDefault(_decoratorsConnectToStores);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var _SpecialsScss = __webpack_require__(675);
	
	var _SpecialsScss2 = _interopRequireDefault(_SpecialsScss);
	
	var _utilsLoopIndex = __webpack_require__(340);
	
	var _utilsLoopIndex2 = _interopRequireDefault(_utilsLoopIndex);
	
	var Specials = (function (_React$Component) {
	  _inherits(Specials, _React$Component);
	
	  _createClass(Specials, null, [{
	    key: 'propTypes',
	    value: {
	      items: _reactImmutableProptypes2['default'].list.isRequired,
	      goals: _reactImmutableProptypes2['default'].map.isRequired,
	      flux: _react.PropTypes.object
	    },
	    enumerable: true
	  }]);
	
	  function Specials(props, context) {
	    _classCallCheck(this, _Specials);
	
	    _get(Object.getPrototypeOf(_Specials.prototype), 'constructor', this).call(this, props, context);
	
	    this.state = {
	      i: 0
	    };
	
	    if (true) {
	      props.goals.forEach(function (goal) {
	        var image = new Image();
	        image.src = goal.get('imgBg');
	      });
	    }
	  }
	
	  _createClass(Specials, [{
	    key: 'handleNav',
	    value: function handleNav(direction) {
	      var i = this.state.i;
	
	      this.setState({
	        i: (0, _utilsLoopIndex2['default'])(i + direction, 0, this.props.items.size - 1)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this = this;
	
	      var i = this.state.i;
	      var items = this.props.items;
	
	      var goals = items.map(function (id) {
	        return _this.props.goals.get(id);
	      }).toList();
	
	      if (goals.size === 0) {
	        return null;
	      }
	
	      return {
	        $$typeof: _typeofReactElement,
	        type: _componentsGoalCardWrapper2['default'],
	        key: null,
	        ref: null,
	        props: _defaultProps(_componentsGoalCardWrapper2['default'].defaultProps, {
	          children: {
	            $$typeof: _typeofReactElement,
	            type: 'div',
	            key: null,
	            ref: null,
	            props: {
	              children: [{
	                $$typeof: _typeofReactElement,
	                type: _componentsCardHeader2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_componentsCardHeader2['default'].defaultProps, {
	                  children: {
	                    $$typeof: _typeofReactElement,
	                    type: 'a',
	                    key: null,
	                    ref: null,
	                    props: {
	                      children: "Спецпроекты",
	                      href: '/site/special'
	                    },
	                    _owner: null
	                  },
	                  onPrevClick: goals.size > 1 ? function () {
	                    return _this.handleNav(-1);
	                  } : undefined,
	                  onNextClick: goals.size > 1 ? function () {
	                    return _this.handleNav(+1);
	                  } : undefined
	                }),
	                _owner: null
	              }, {
	                $$typeof: _typeofReactElement,
	                type: _reactAddonsCssTransitionGroup2['default'],
	                key: null,
	                ref: null,
	                props: _defaultProps(_reactAddonsCssTransitionGroup2['default'].defaultProps, {
	                  children: goals.get(i) && this.renderGoal(goals.get(i)),
	                  transitionEnterTimeout: 300,
	                  transitionLeaveTimeout: 300,
	                  transitionName: 't-fade'
	                }),
	                _owner: null
	              }],
	              className: (0, _SpecialsScss2['default'])('main')
	            },
	            _owner: null
	          },
	          style: { minHeight: 350 }
	        }),
	        _owner: null
	      };
	    }
	  }, {
	    key: 'renderGoal',
	    value: function renderGoal(goal) {
	      var goalsActions = this.props.flux.getActions('goals');
	      return {
	        $$typeof: _typeofReactElement,
	        type: _componentsSpecialGoalCard2['default'],
	        key: goal.get('id'),
	        ref: null,
	        props: _defaultProps(_componentsSpecialGoalCard2['default'].defaultProps, {
	          wrapperSize: '1',
	          goal: goal,
	          onUnsubscribe: function () {
	            return goalsActions.unsubscribe(goal.get('id'));
	          },
	          onSubscribe: function () {
	            return goalsActions.subscribe(goal.get('id'));
	          },
	          onLike: function () {
	            return goalsActions.like(goal.get('id'));
	          }
	        }),
	        _owner: null
	      };
	    }
	  }]);
	
	  var _Specials = Specials;
	  Specials = (0, _decoratorsConnectToStores2['default'])({
	    goals: function goals(store) {
	      return { goals: store.state.goals };
	    },
	    goalsList: function goalsList(store) {
	      return { items: store.state.specials };
	    }
	  })(Specials) || Specials;
	  Specials = (0, _decoratorsWithStyles2['default'])(_SpecialsScss2['default'])(Specials) || Specials;
	  return Specials;
	})(_react2['default'].Component);
	
	exports['default'] = Specials;
	module.exports = exports['default'];

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CardHeaderScss = __webpack_require__(668);
	
	var _CardHeaderScss2 = _interopRequireDefault(_CardHeaderScss);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var _componentsIcon = __webpack_require__(53);
	
	var _componentsIcon2 = _interopRequireDefault(_componentsIcon);
	
	var _ref = {
	  $$typeof: _typeofReactElement,
	  type: _componentsIcon2['default'],
	  key: null,
	  ref: null,
	  props: _defaultProps(_componentsIcon2['default'].defaultProps, {
	    type: 'nav-fwd-thin'
	  }),
	  _owner: null
	};
	var _ref2 = {
	  $$typeof: _typeofReactElement,
	  type: _componentsIcon2['default'],
	  key: null,
	  ref: null,
	  props: _defaultProps(_componentsIcon2['default'].defaultProps, {
	    type: 'nav-fwd-thin'
	  }),
	  _owner: null
	};
	
	var CardHeader = (function (_React$Component) {
	  _inherits(CardHeader, _React$Component);
	
	  function CardHeader() {
	    _classCallCheck(this, _CardHeader);
	
	    _get(Object.getPrototypeOf(_CardHeader.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(CardHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var onNextClick = _props.onNextClick;
	      var onPrevClick = _props.onPrevClick;
	      var next = _props.next;
	      var prev = _props.prev;
	
	      return {
	        $$typeof: _typeofReactElement,
	        type: 'div',
	        key: null,
	        ref: null,
	        props: {
	          children: [children, (onNextClick || next) && {
	            $$typeof: _typeofReactElement,
	            type: 'a',
	            key: null,
	            ref: null,
	            props: {
	              children: _ref,
	              onClick: onNextClick,
	              href: next,
	              className: (0, _CardHeaderScss2['default'])('nav', ['next'])
	            },
	            _owner: null
	          }, (onPrevClick || prev) && {
	            $$typeof: _typeofReactElement,
	            type: 'a',
	            key: null,
	            ref: null,
	            props: {
	              children: _ref2,
	              onClick: onPrevClick,
	              href: prev,
	              className: (0, _CardHeaderScss2['default'])('nav', ['prev'])
	            },
	            _owner: null
	          }],
	          className: (0, _CardHeaderScss2['default'])('main')
	        },
	        _owner: null
	      };
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      children: _react.PropTypes.any,
	      onNextClick: _react.PropTypes.func,
	      onPrevClick: _react.PropTypes.func,
	      next: _react.PropTypes.string,
	      prev: _react.PropTypes.string
	    },
	    enumerable: true
	  }]);
	
	  var _CardHeader = CardHeader;
	  CardHeader = (0, _decoratorsWithStyles2['default'])(_CardHeaderScss2['default'])(CardHeader) || CardHeader;
	  return CardHeader;
	})(_react2['default'].Component);
	
	exports['default'] = CardHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(669);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(670);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./CardHeader.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./CardHeader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, ".VdkB7mpEV0{font-size:22px;font-weight:700;position:relative;box-sizing:border-box;height:3pc;padding-top:13px;text-align:center;text-transform:uppercase;letter-spacing:1px;color:#fff;background-color:#2ab8d5}.VdkB7mpEV0 a{color:#fff;text-decoration:none}._3WAEyU6y3Q{position:absolute;top:2px;padding:10px;cursor:pointer;color:#fff}._2WVqXhc_DO{right:0}._1pFf7-2SCC{left:0}._1pFf7-2SCC .icon{transform:rotate(180deg)}", ""]);
	
	// exports
	exports.locals = {
		"main": "VdkB7mpEV0",
		"nav": "_3WAEyU6y3Q",
		"nav--next": "_2WVqXhc_DO",
		"nav--prev": "_1pFf7-2SCC"
	};

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImmutableProptypes = __webpack_require__(83);
	
	var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);
	
	var _componentsLike = __webpack_require__(140);
	
	var _componentsLike2 = _interopRequireDefault(_componentsLike);
	
	var _componentsSubscribe = __webpack_require__(606);
	
	var _componentsSubscribe2 = _interopRequireDefault(_componentsSubscribe);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var _SpecialGoalCardScss = __webpack_require__(672);
	
	var _SpecialGoalCardScss2 = _interopRequireDefault(_SpecialGoalCardScss);
	
	var SpecialGoalCard = (function (_React$Component) {
	  _inherits(SpecialGoalCard, _React$Component);
	
	  function SpecialGoalCard() {
	    _classCallCheck(this, _SpecialGoalCard);
	
	    _get(Object.getPrototypeOf(_SpecialGoalCard.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(SpecialGoalCard, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var goal = _props.goal;
	      var onUnsubscribe = _props.onUnsubscribe;
	      var onSubscribe = _props.onSubscribe;
	      var onLike = _props.onLike;
	
	      var itemProps = {
	        style: {
	          backgroundImage: 'url(' + goal.get('img') + ')',
	          backgroundColor: goal.get('imgBg')
	        },
	        className: (0, _SpecialGoalCardScss2['default'])('item'),
	        key: goal.get('id')
	      };
	
	      return _react2['default'].createElement(
	        'div',
	        itemProps,
	        {
	          $$typeof: _typeofReactElement,
	          type: 'a',
	          key: null,
	          ref: null,
	          props: {
	            href: goal.get('url'),
	            className: (0, _SpecialGoalCardScss2['default'])('link')
	          },
	          _owner: null
	        },
	        {
	          $$typeof: _typeofReactElement,
	          type: 'h3',
	          key: null,
	          ref: null,
	          props: {
	            children: {
	              $$typeof: _typeofReactElement,
	              type: 'span',
	              key: null,
	              ref: null,
	              props: {
	                dangerouslySetInnerHTML: { __html: goal.get('name') }
	              },
	              _owner: null
	            },
	            className: (0, _SpecialGoalCardScss2['default'])('title')
	          },
	          _owner: null
	        },
	        {
	          $$typeof: _typeofReactElement,
	          type: 'div',
	          key: null,
	          ref: null,
	          props: {
	            children: [Number(goal.get('is_own')) === 0 && {
	              $$typeof: _typeofReactElement,
	              type: _componentsSubscribe2['default'],
	              key: null,
	              ref: null,
	              props: _defaultProps(_componentsSubscribe2['default'].defaultProps, {
	                subscribed: parseInt(goal.get('subscription'), 10) > 0,
	                counter: Number(goal.get('count_subscriptions')),
	                onClick: Number(goal.get('subscription')) > 0 ? onUnsubscribe : onSubscribe
	              }),
	              _owner: null
	            }, {
	              $$typeof: _typeofReactElement,
	              type: _componentsLike2['default'],
	              key: null,
	              ref: null,
	              props: _defaultProps(_componentsLike2['default'].defaultProps, {
	                liked: goal.get('liked'),
	                disabled: goal.get('is_own') > 0,
	                counter: parseInt(goal.get('rating'), 10),
	                onClick: onLike
	              }),
	              _owner: null
	            }],
	            className: (0, _SpecialGoalCardScss2['default'])('actions')
	          },
	          _owner: null
	        }
	      );
	    }
	  }], [{
	    key: 'propTypes',
	    value: {
	      goal: _reactImmutableProptypes2['default'].map.isRequired,
	      onUnsubscribe: _react.PropTypes.func,
	      onSubscribe: _react.PropTypes.func,
	      onLike: _react.PropTypes.func
	    },
	    enumerable: true
	  }]);
	
	  var _SpecialGoalCard = SpecialGoalCard;
	  SpecialGoalCard = (0, _decoratorsWithStyles2['default'])(_SpecialGoalCardScss2['default'])(SpecialGoalCard) || SpecialGoalCard;
	  return SpecialGoalCard;
	})(_react2['default'].Component);
	
	exports['default'] = SpecialGoalCard;
	module.exports = exports['default'];

/***/ }),

/***/ 672:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(673);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(674);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./SpecialGoalCard.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./SpecialGoalCard.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._3mltOkrs2n{z-index:1;top:3pc;background-position:center;background-size:cover}._3mltOkrs2n,._3mltOkrs2n:before{position:absolute;left:0;bottom:0;right:0}._3mltOkrs2n:before{z-index:0;height:75%;content:\"\";background-image:linear-gradient(transparent,rgba(0,0,0,.4))}._3Zrp_8dV9c{position:absolute;z-index:2;top:0;right:0;left:0;bottom:0}._1UPcf2GDg2{font-size:36px;font-weight:700;z-index:1;bottom:60px;overflow:hidden;margin:0 0 15px;line-height:34px;color:#fff}._1UPcf2GDg2,._2AX8Ef6v_3{position:absolute;left:20px;right:20px;text-align:center}._2AX8Ef6v_3{bottom:30px}._2AX8Ef6v_3 .like-w{float:none;display:inline-block;vertical-align:middle;margin-left:10px}._2AX8Ef6v_3 .btn{position:relative;z-index:5}", ""]);
	
	// exports
	exports.locals = {
		"item": "_3mltOkrs2n",
		"link": "_3Zrp_8dV9c",
		"title": "_1UPcf2GDg2",
		"actions": "_2AX8Ef6v_3"
	};

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(676);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(677);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./Specials.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./Specials.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, ".t-fade{display:block}.t-fade-enter{opacity:0;transition:opacity .3s}.t-fade-enter-active{opacity:1}.t-fade-leave{z-index:0;opacity:1;transition:opacity .3s;transition-delay:.2s}.t-fade-leave-active{opacity:0}", ""]);
	
	// exports


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MostActiveScss = __webpack_require__(679);
	
	var _MostActiveScss2 = _interopRequireDefault(_MostActiveScss);
	
	var _componentsGoalCardWrapper = __webpack_require__(648);
	
	var _componentsGoalCardWrapper2 = _interopRequireDefault(_componentsGoalCardWrapper);
	
	var _componentsAvatar = __webpack_require__(89);
	
	var _componentsAvatar2 = _interopRequireDefault(_componentsAvatar);
	
	var _componentsSpinner = __webpack_require__(561);
	
	var _componentsSpinner2 = _interopRequireDefault(_componentsSpinner);
	
	var _utilsRequest = __webpack_require__(44);
	
	var _BlockHeader = __webpack_require__(682);
	
	var _BlockHeader2 = _interopRequireDefault(_BlockHeader);
	
	var _utilsLang = __webpack_require__(205);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var _ref = {
		$$typeof: _typeofReactElement,
		type: _componentsSpinner2['default'],
		key: null,
		ref: null,
		props: _defaultProps(_componentsSpinner2['default'].defaultProps, {
			color: '#00F4F6'
		}),
		_owner: null
	};
	
	var MostActive = (function (_React$Component) {
		_inherits(MostActive, _React$Component);
	
		_createClass(MostActive, null, [{
			key: 'propTypes',
			value: {
				initialData: _react.PropTypes.array
			},
			enumerable: true
		}]);
	
		function MostActive(props, context) {
			_classCallCheck(this, _MostActive);
	
			_get(Object.getPrototypeOf(_MostActive.prototype), 'constructor', this).call(this, props, context);
	
			this.state = {
				filter: 'week',
				data: {
					week: this.props.initialData
				}
			};
			if (!props.initialData) {
				this.handleNav('week');
			}
		}
	
		_createClass(MostActive, [{
			key: 'handleNav',
			value: function handleNav(filter) {
				var _ref2, users_top;
	
				return regeneratorRuntime.async(function handleNav$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							this.setState({ filter: filter });
	
							if (this.state.data[filter]) {
								context$2$0.next = 13;
								break;
							}
	
							context$2$0.prev = 2;
							context$2$0.next = 5;
							return regeneratorRuntime.awrap((0, _utilsRequest.get)('/user/getTop', {
								period: filter
							}));
	
						case 5:
							_ref2 = context$2$0.sent;
							users_top = _ref2.users_top;
	
							this.setState({
								data: _extends({}, this.state.data, _defineProperty({}, filter, users_top))
							});
							context$2$0.next = 13;
							break;
	
						case 10:
							context$2$0.prev = 10;
							context$2$0.t0 = context$2$0['catch'](2);
	
							console.log(context$2$0.t0);
	
						case 13:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this, [[2, 10]]);
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state;
				var filter = _state.filter;
				var data = _state.data;
	
				return {
					$$typeof: _typeofReactElement,
					type: _componentsGoalCardWrapper2['default'],
					key: null,
					ref: null,
					props: _defaultProps(_componentsGoalCardWrapper2['default'].defaultProps, {
						children: [{
							$$typeof: _typeofReactElement,
							type: _BlockHeader2['default'],
							key: null,
							ref: null,
							props: _defaultProps(_BlockHeader2['default'].defaultProps, {
								children: "Самые <br /> активные",
								currentItem: filter,
								onNav: this.handleNav.bind(this)
							}),
							_owner: null
						}, {
							$$typeof: _typeofReactElement,
							type: 'div',
							key: null,
							ref: null,
							props: {
								children: [data[filter] && data[filter].map(function (user) {
									return {
										$$typeof: _typeofReactElement,
										type: 'a',
										key: user.id,
										ref: null,
										props: {
											children: [{
												$$typeof: _typeofReactElement,
												type: _componentsAvatar2['default'],
												key: null,
												ref: null,
												props: _defaultProps(_componentsAvatar2['default'].defaultProps, {
													size: 'm',
													user_id: user.id,
													avatar: user.avatar
												}),
												_owner: null
											}, {
												$$typeof: _typeofReactElement,
												type: 'div',
												key: null,
												ref: null,
												props: {
													children: [{
														$$typeof: _typeofReactElement,
														type: 'h4',
														key: null,
														ref: null,
														props: {
															children: user.username,
															className: (0, _MostActiveScss2['default'])('name')
														},
														_owner: null
													}, {
														$$typeof: _typeofReactElement,
														type: 'p',
														key: null,
														ref: null,
														props: {
															children: [user.count_posts, ' ', (0, _utilsLang.declension)("пост|поста|постов", user.count_posts)],
															className: (0, _MostActiveScss2['default'])('metric')
														},
														_owner: null
													}, {
														$$typeof: _typeofReactElement,
														type: 'p',
														key: null,
														ref: null,
														props: {
															children: [user.count_comments, ' ', (0, _utilsLang.declension)("комментарий|комментария|комментариев", user.count_comments)],
															className: (0, _MostActiveScss2['default'])('metric')
														},
														_owner: null
													}],
													className: (0, _MostActiveScss2['default'])('info')
												},
												_owner: null
											}],
											href: '/user/' + user.id,
											className: (0, _MostActiveScss2['default'])('item')
										},
										_owner: null
									};
								}), !data[filter] && {
									$$typeof: _typeofReactElement,
									type: 'div',
									key: null,
									ref: null,
									props: {
										children: _ref,
										className: (0, _MostActiveScss2['default'])('loader')
									},
									_owner: null
								}],
								className: (0, _MostActiveScss2['default'])('list')
							},
							_owner: null
						}],
						className: (0, _MostActiveScss2['default'])('main')
					}),
					_owner: null
				};
			}
		}]);
	
		var _MostActive = MostActive;
		MostActive = (0, _decoratorsWithStyles2['default'])(_MostActiveScss2['default'])(MostActive) || MostActive;
		return MostActive;
	})(_react2['default'].Component);
	
	exports['default'] = MostActive;
	module.exports = exports['default'];

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(680);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(681);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./MostActive.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./MostActive.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._37HdW2DbHX{color:#fff;background-color:#8c96a5;text-align:center}.mTrAj3Hjth{display:inline-block;box-sizing:border-box;max-width:100%;padding:5px 50px}.eA02_f1DBx{padding:15px 0;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;text-align:left;text-decoration:none;color:#d7dde4}.YrBInVs6zv{margin-left:10px}.qcA5h_HlVN{font-weight:700;font-size:14px;color:#fff}._1jcvs8HeOa{font-size:9pt;margin-top:5px}._2yELCoUskb{padding:50px 0}", ""]);
	
	// exports
	exports.locals = {
		"main": "_37HdW2DbHX",
		"list": "mTrAj3Hjth",
		"item": "eA02_f1DBx",
		"info": "YrBInVs6zv",
		"name": "qcA5h_HlVN",
		"metric": "_1jcvs8HeOa",
		"loader": "_2yELCoUskb"
	};

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BlockHeaderScss = __webpack_require__(683);
	
	var _BlockHeaderScss2 = _interopRequireDefault(_BlockHeaderScss);
	
	var _BlockTitle = __webpack_require__(686);
	
	var _BlockTitle2 = _interopRequireDefault(_BlockTitle);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var values = {"week":"неделю","month":"месяц","year":"год"};
	
	var BlockHeader = (function (_React$Component) {
		_inherits(BlockHeader, _React$Component);
	
		function BlockHeader() {
			_classCallCheck(this, _BlockHeader);
	
			_get(Object.getPrototypeOf(_BlockHeader.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(BlockHeader, [{
			key: 'render',
			value: function render() {
				var _props = this.props;
				var children = _props.children;
				var currentItem = _props.currentItem;
				var onNav = _props.onNav;
	
				return {
					$$typeof: _typeofReactElement,
					type: 'header',
					key: null,
					ref: null,
					props: {
						children: [{
							$$typeof: _typeofReactElement,
							type: _BlockTitle2['default'],
							key: null,
							ref: null,
							props: _defaultProps(_BlockTitle2['default'].defaultProps, {
								children: children
							}),
							_owner: null
						}, {
							$$typeof: _typeofReactElement,
							type: 'ul',
							key: null,
							ref: null,
							props: {
								children: Object.keys(values).map(function (key) {
									return {
										$$typeof: _typeofReactElement,
										type: 'li',
										key: key,
										ref: null,
										props: {
											children: {
												$$typeof: _typeofReactElement,
												type: 'a',
												key: null,
												ref: null,
												props: {
													children: values[key]
												},
												_owner: null
											},
											onClick: function () {
												return onNav(key);
											},
											className: (0, _BlockHeaderScss2['default'])('item', { active: currentItem === key })
										},
										_owner: null
									};
								}),
								className: (0, _BlockHeaderScss2['default'])('menu')
							},
							_owner: null
						}],
						className: (0, _BlockHeaderScss2['default'])('main')
					},
					_owner: null
				};
			}
		}], [{
			key: 'propTypes',
			value: {
				currentItem: _react.PropTypes.oneOf(Object.keys(values)).isRequired,
				onNav: _react.PropTypes.func.isRequired,
				children: _react.PropTypes.any
			},
			enumerable: true
		}]);
	
		var _BlockHeader = BlockHeader;
		BlockHeader = (0, _decoratorsWithStyles2['default'])(_BlockHeaderScss2['default'])(BlockHeader) || BlockHeader;
		return BlockHeader;
	})(_react2['default'].Component);
	
	exports['default'] = BlockHeader;
	module.exports = exports['default'];

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(684);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(685);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./BlockHeader.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./BlockHeader.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._3gSpPeRSbg{font-size:14px;padding:15px 0;border-bottom:1px solid hsla(0,0%,100%,.2)}._3DfpQrtWe-{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}._1GXcX0EqY4 a{padding:0 5px;text-decoration:underline;cursor:pointer;color:inherit}._2kNz8lE-vQ a{opacity:.7;cursor:default;text-decoration:none}", ""]);
	
	// exports
	exports.locals = {
		"main": "_3gSpPeRSbg",
		"menu": "_3DfpQrtWe-",
		"item": "_1GXcX0EqY4",
		"item--active": "_2kNz8lE-vQ"
	};

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BlockTitleScss = __webpack_require__(687);
	
	var _BlockTitleScss2 = _interopRequireDefault(_BlockTitleScss);
	
	var BlockTitle = (function (_React$Component) {
		_inherits(BlockTitle, _React$Component);
	
		function BlockTitle() {
			_classCallCheck(this, BlockTitle);
	
			_get(Object.getPrototypeOf(BlockTitle.prototype), 'constructor', this).apply(this, arguments);
		}
	
		_createClass(BlockTitle, [{
			key: 'render',
			value: function render() {
				var _props = this.props;
				var children = _props.children;
	
				var rest = _objectWithoutProperties(_props, ['children']);
	
				if (typeof children === 'string') {
					return _react2['default'].createElement('h3', _extends({
						className: (0, _BlockTitleScss2['default'])('title'),
						dangerouslySetInnerHTML: {
							__html: children
						}
					}, rest));
				} else {
					return _react2['default'].createElement(
						'h3',
						_extends({ className: (0, _BlockTitleScss2['default'])('title') }, rest),
						children
					);
				}
			}
		}], [{
			key: 'propTypes',
			value: {
				children: _react2['default'].PropTypes.any
			},
			enumerable: true
		}]);
	
		return BlockTitle;
	})(_react2['default'].Component);
	
	exports['default'] = BlockTitle;
	module.exports = exports['default'];

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(688);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(689);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./BlockTitle.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./BlockTitle.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._1evcn3axWZ{font-size:22px;font-weight:700;margin-bottom:10px;line-height:1;letter-spacing:1px;text-transform:uppercase;text-align:center}", ""]);
	
	// exports
	exports.locals = {
		"title": "_1evcn3axWZ"
	};

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
		value: true
	});
	
	var _typeofReactElement = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 60103;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defaultProps(defaultProps, props) { if (defaultProps) { for (var propName in defaultProps) { if (typeof props[propName] === 'undefined') { props[propName] = defaultProps[propName]; } } } return props; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(52);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MostDiscussedScss = __webpack_require__(691);
	
	var _MostDiscussedScss2 = _interopRequireDefault(_MostDiscussedScss);
	
	var _componentsGoalCardWrapper = __webpack_require__(648);
	
	var _componentsGoalCardWrapper2 = _interopRequireDefault(_componentsGoalCardWrapper);
	
	var _componentsIcon = __webpack_require__(53);
	
	var _componentsIcon2 = _interopRequireDefault(_componentsIcon);
	
	var _componentsSpinner = __webpack_require__(561);
	
	var _componentsSpinner2 = _interopRequireDefault(_componentsSpinner);
	
	var _utilsRequest = __webpack_require__(44);
	
	var _BlockHeader = __webpack_require__(682);
	
	var _BlockHeader2 = _interopRequireDefault(_BlockHeader);
	
	var _decoratorsWithStyles = __webpack_require__(67);
	
	var _decoratorsWithStyles2 = _interopRequireDefault(_decoratorsWithStyles);
	
	var _ref = {
		$$typeof: _typeofReactElement,
		type: _componentsSpinner2['default'],
		key: null,
		ref: null,
		props: _defaultProps(_componentsSpinner2['default'].defaultProps, {
			color: '#00F4F6'
		}),
		_owner: null
	};
	
	var MostDiscussed = (function (_React$Component) {
		_inherits(MostDiscussed, _React$Component);
	
		_createClass(MostDiscussed, null, [{
			key: 'propTypes',
			value: {
				initialData: _react.PropTypes.array
			},
			enumerable: true
		}]);
	
		function MostDiscussed(props, context) {
			_classCallCheck(this, _MostDiscussed);
	
			_get(Object.getPrototypeOf(_MostDiscussed.prototype), 'constructor', this).call(this, props, context);
	
			this.state = {
				filter: 'week',
				data: {
					week: this.props.initialData
				}
			};
			if (!props.initialData) {
				this.handleNav('week');
			}
		}
	
		_createClass(MostDiscussed, [{
			key: 'handleNav',
			value: function handleNav(filter) {
				var _ref2, goals_top;
	
				return regeneratorRuntime.async(function handleNav$(context$2$0) {
					while (1) switch (context$2$0.prev = context$2$0.next) {
						case 0:
							this.setState({ filter: filter });
	
							if (this.state.data[filter]) {
								context$2$0.next = 13;
								break;
							}
	
							context$2$0.prev = 2;
							context$2$0.next = 5;
							return regeneratorRuntime.awrap((0, _utilsRequest.get)('/goal/getTop', {
								period: filter
							}));
	
						case 5:
							_ref2 = context$2$0.sent;
							goals_top = _ref2.goals_top;
	
							this.setState({
								data: _extends({}, this.state.data, _defineProperty({}, filter, goals_top))
							});
							context$2$0.next = 13;
							break;
	
						case 10:
							context$2$0.prev = 10;
							context$2$0.t0 = context$2$0['catch'](2);
	
							console.log(context$2$0.t0);
	
						case 13:
						case 'end':
							return context$2$0.stop();
					}
				}, null, this, [[2, 10]]);
			}
		}, {
			key: 'render',
			value: function render() {
				var _state = this.state;
				var filter = _state.filter;
				var data = _state.data;
	
				return {
					$$typeof: _typeofReactElement,
					type: _componentsGoalCardWrapper2['default'],
					key: null,
					ref: null,
					props: _defaultProps(_componentsGoalCardWrapper2['default'].defaultProps, {
						children: [{
							$$typeof: _typeofReactElement,
							type: _BlockHeader2['default'],
							key: null,
							ref: null,
							props: _defaultProps(_BlockHeader2['default'].defaultProps, {
								children: "Cамые <br /> обсуждаемые",
								currentItem: filter,
								onNav: this.handleNav.bind(this)
							}),
							_owner: null
						}, {
							$$typeof: _typeofReactElement,
							type: 'div',
							key: null,
							ref: null,
							props: {
								children: [data[filter] && data[filter].map(function (goal) {
									return {
										$$typeof: _typeofReactElement,
										type: 'a',
										key: goal.id,
										ref: null,
										props: {
											children: [{
												$$typeof: _typeofReactElement,
												type: 'p',
												key: null,
												ref: null,
												props: {
													className: (0, _MostDiscussedScss2['default'])('category'),
													dangerouslySetInnerHTML: {
														__html: decodeURI(goal.category_name)
													}
												},
												_owner: null
											}, {
												$$typeof: _typeofReactElement,
												type: 'h4',
												key: null,
												ref: null,
												props: {
													className: (0, _MostDiscussedScss2['default'])('name'),
													dangerouslySetInnerHTML: {
														__html: decodeURI(goal.name)
													}
												},
												_owner: null
											}, {
												$$typeof: _typeofReactElement,
												type: 'span',
												key: null,
												ref: null,
												props: {
													children: [{
														$$typeof: _typeofReactElement,
														type: _componentsIcon2['default'],
														key: null,
														ref: null,
														props: _defaultProps(_componentsIcon2['default'].defaultProps, {
															type: 'comment',
															className: (0, _MostDiscussedScss2['default'])('commentsIcon')
														}),
														_owner: null
													}, goal.count_comments],
													className: (0, _MostDiscussedScss2['default'])('comments')
												},
												_owner: null
											}],
											href: goal.url,
											className: (0, _MostDiscussedScss2['default'])('item')
										},
										_owner: null
									};
								}), !data[filter] && {
									$$typeof: _typeofReactElement,
									type: 'div',
									key: null,
									ref: null,
									props: {
										children: _ref,
										className: (0, _MostDiscussedScss2['default'])('loader')
									},
									_owner: null
								}],
								className: (0, _MostDiscussedScss2['default'])('list')
							},
							_owner: null
						}],
						className: (0, _MostDiscussedScss2['default'])('main')
					}),
					_owner: null
				};
			}
		}]);
	
		var _MostDiscussed = MostDiscussed;
		MostDiscussed = (0, _decoratorsWithStyles2['default'])(_MostDiscussedScss2['default'])(MostDiscussed) || MostDiscussed;
		return MostDiscussed;
	})(_react2['default'].Component);
	
	exports['default'] = MostDiscussed;
	module.exports = exports['default'];

/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(692);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(693);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./MostDiscussed.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./MostDiscussed.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._1v9J1ZEXqi{text-align:center;color:#fff;background-color:#4b5765}._3rNblTA0_Z{display:block;padding:30px 0 40px;text-decoration:none;color:inherit}._3rNblTA0_Z+._3rNblTA0_Z{border-top:1px solid #6f7984}._1QBdJ1cCGe{font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#d8dde4}._2lLA5oWQ7u{font-size:18px;font-weight:700;margin:6px 0}._3bzwuVAjzT{font-weight:700;color:#00f4f6}._19DZbK4cwe{margin-right:5px}._3nJlWp0BAe{padding:50px 0}", ""]);
	
	// exports
	exports.locals = {
		"main": "_1v9J1ZEXqi",
		"item": "_3rNblTA0_Z",
		"category": "_1QBdJ1cCGe",
		"name": "_2lLA5oWQ7u",
		"comments": "_3bzwuVAjzT",
		"commentsIcon": "_19DZbK4cwe",
		"loader": "_3nJlWp0BAe"
	};

/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

	// bem-module-loader
	// wrap css module in func that generates className
	var content = __webpack_require__(695);
	if(typeof content === 'string') content = [[module.id, content, '']];
	var b_ = __webpack_require__(54);
	var realContent = (typeof content.locals === 'object') ? content.locals : content
	function bemModule() {
	return b_.apply(null, Array.prototype.slice.call(arguments)).split(' ').map(function(c) { return realContent[c];}).join(' ');
	}
	bemModule.content = content;
	module.exports = bemModule;

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(696);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(66)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./GoalsPage.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./GoalsPage.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(65)();
	// imports
	
	
	// module
	exports.push([module.id, "._1EJ48QAfo1{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-pack:justify;justify-content:space-between}", ""]);
	
	// exports
	exports.locals = {
		"list": "_1EJ48QAfo1"
	};

/***/ })

});


// WEBPACK FOOTER //
// 5.ru.5-298ab1b1a98c38625b67-built.js